'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var styledComponents = require('./styled-components.js');

var ProgressBar = function (props) {
    var _a = props.value, value = _a === void 0 ? 0 : _a, _b = props.doneText, doneText = _b === void 0 ? '' : _b, styles = props.styles;
    var classes = styledComponents.useStyles(styles === null || styles === void 0 ? void 0 : styles.color, styles === null || styles === void 0 ? void 0 : styles.height)();
    var getLabel = function () { return (value < 100 || !doneText ? value + "%" : doneText); };
    return (React__default.createElement(styledComponents.Container, null,
        React__default.createElement("div", { className: classes.label },
            React__default.createElement("span", null,
                React__default.createElement(core.Typography, { "data-testid": 'progress-label' }, getLabel()))),
        React__default.createElement(core.LinearProgress, { variant: 'determinate', classes: {
                root: classes.root,
                bar: classes.bar,
            }, value: value })));
};

module.exports = ProgressBar;
